import React from 'react'
import { Link } from 'react-router-dom';
import { Select, MenuItem } from "@material-ui/core"

import SpotlioIcon from '../../Icon';
import TabGenerator from './TabGenerator';
import Drawer from '../../Drawer';
// import CurrencySelector from '../../CurrencySelector';
import Seasonality from "../../Seasonality";

import IntlMessage from '../../../LocaleEngine';
import { getSystemSettings, getSessionId, getDestination, setSessionId } from '../../../utils/SettingsRetriever';
import SalesIDRetriever from '../../../utils/SalesIDRetriever';
import request from '../../../utils/request';
import PushHistory from '../../../utils/PushHistory';
import { getCookie } from '../../../utils/CookiesRetriever';

import './index.scss';

export default class Mobile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dataGuest: null
        }
    }

    componentDidMount() {
        const configuration = getSystemSettings();
        const language = configuration.head.languages && configuration.head.languages[0];
        
        this.setState({configuration, language});
       this.handleGetCustomer();

    }

    handleGetCustomer = () => {
        request({
            url: getSystemSettings().api + '/inntopia/customer',
            method: 'POST',
            data: {
                sessionId: getSessionId(),
                salesId: SalesIDRetriever()
            }
        }).then((result) => {
            if(result.status === 200){
                if (result.data.EmailAddress) {
                    let state = this.state;
                    state.dataGuest = result.data;
                    state.loading = false;
                    this.setState(state);
                    //this.pageView(state);
                } else throw Error('not logged in');
            } else throw Error('not logged in');
        }).catch(err => {
            console.error(err);
            if (err.message === 'not logged in') {
                //PushHistory('/login');
            }
        });
    }

    toggleMenu = () => {
        this.props.toggleMenu()
    }

    getDestinationText = (multiDestination) => {
        if (getDestination() && getDestination().length){
            if (getDestination().length > 1){
                return "Multiple Destinations"
            }
            if ( multiDestination.list.find( destination => parseInt(destination.id) === parseInt( getDestination()[0] ) ) ){
                return multiDestination.list.find( destination => parseInt(destination.id) === parseInt( getDestination()[0] ) ).name
            }
        }
        return "Choose Park"
    }

    redirectToDashboard = () => {
        request({
            url: getSystemSettings().api + '/inntopia/session?salesid=' + SalesIDRetriever(),
            method: 'GET'
        })
        .then( (result) => {
            setSessionId(result.data.SessionId);
            PushHistory('/b2b/dashboard');
        });
    }

    render() {
        const { configuration, language, dataGuest } = this.state;
        if(!configuration) return null;
        let headerImage = '';
        if(! !configuration.assets.mobile.background) headerImage = configuration.assets.mobile.background;

        let showLanguage = false;
        if(! !configuration.head.multilanguage) showLanguage = configuration.head.multilanguage;

        // let showCurrency = false;
        // if(! !configuration.head.multicurrency) showCurrency = configuration.head.multicurrency;

        let showProfile = false;
        if(! !configuration.head.profile) showProfile = configuration.head.profile;

        let multiDestination = false;
        if (configuration.multiDestination && configuration.multiDestination.enabled) multiDestination = true;
        return (
            <Drawer
                disablePortal={true}
                open={this.props.menu}
                className="categoriesMenu"
                onEscapeKeyDown={() => this.props.toggleMenu(false)} 
                onBackdropClick={() => this.props.toggleMenu(false)} 
                anchor={"right"}
            >
                {
                    headerImage !== '' ?
                    <div className="header">
                        <img alt={configuration.head.title} src={headerImage} />
                    </div> : ''
                }
                {
                    configuration && configuration.seasonality && configuration.seasonality.enabled && configuration.seasonality.toggler
                    ? <Seasonality mobile={true} seasonality={configuration.seasonality} />
                    : null
                }
                {
                    showProfile ?
                        this.state.dataGuest
                        ? <div className="logged">
                            <div className="initial">
                                {dataGuest.FirstName[0]}
                                {dataGuest.LastName[0]}
                            </div>
                            <div className="userData">
                                <div className="name">
                                    {`${dataGuest.FirstName} ${dataGuest.LastName}`}
                                </div>
                                <div className="email">
                                    {dataGuest.EmailAddress}
                                </div>
                            </div>
                        </div>
                        : <Link to={getSystemSettings().urlPrefix + '/account'} className="myAccount">
                            <SpotlioIcon icon="spotlio-user" />
                            <span className="optionText">
                                Login
                                {/* <IntlMessage id="header.info.my_account" /> */}
                            </span>
                        </Link>
                    : ''
                }
                {
                    JSON.parse(getCookie('b2b')) 
                    && <div className={"menuItem"} onClick={() => this.redirectToDashboard()}>
                        <IntlMessage id="b2b.header.buttons.dashboard" />
                    </div>
                }
                <div className="menu">
                    <div className="options">
                    {/*
                        showCurrency ?
                        <div className="menuItem">
                            <CurrencySelector mode="b2c" />
                        </div>
                        : ''
                    */}
                    {/* 
                        <SpotlioIcon icon="fa-language" />
                        <span className="optionText"><IntlMessage id="header.info.language" /></span>
                    */}
                    {
                        showLanguage && configuration.head && configuration.head.languages ?
                        <Select 
                            value={language.short}
                            defaultValue={"en"}
                            IconComponent={() => <SpotlioIcon icon="feather-chevron-down" />} 
                            className="menuItem"
                            onChannge={(e) => this.setState({language: e.target.value})}
                        >
                            {
                                configuration.head.languages.map(lang => {
                                    return (
                                        <MenuItem value={lang.short}>{lang.name}</MenuItem>
                                    )
                                })
                            }
                            
                        </Select>
                        : ''
                    }
                    </div>
                    {
                        multiDestination ?
                        <Link to="/select_destination" className="option destination" style={{textDecoration: 'none'}}>
                            <span className="categoryText">
                                Change destination: <IntlMessage id={this.getDestinationText(configuration.multiDestination)} />
                            </span>
                        </Link>
                        : null
                    }
                    <TabGenerator toggleMenu={this.toggleMenu.bind(this)} isMobile={true} cart={false}/>
                    {
                        configuration.app &&
                        configuration.app.menu &&
                        configuration.app.menu.returnTo &&
                        (configuration.app.menu.returnTo.label && configuration.app.menu.returnTo.url) &&
                        <a href={configuration.app.menu.returnTo.url} style={{textDecoration: 'none'}}>
                            <div className="option">
                                <span className="categoryText">
                                    {configuration.app.menu.returnTo.label}
                                </span>
                            </div>
                        </a>
                    }
                </div>
                <div className="bottommenu">
                    <SpotlioIcon icon={"feather-x"} onClick={()=> this.props.toggleMenu(false)} size={24} className="closemenu" />
                </div>
            </Drawer>
        );
    }
}
